import { render, staticRenderFns } from "./IndexUserDataAvg.vue?vue&type=template&id=5ecea128&scoped=true&"
import script from "./IndexUserDataAvg.vue?vue&type=script&lang=js&"
export * from "./IndexUserDataAvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecea128",
  null
  
)

export default component.exports